"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function FindResult({ selected, content, onClick, searchValue: search, replaceValue, }) {
    const matched = content === null || content === void 0 ? void 0 : content.match(new RegExp(search, "gi"));
    return (react_1.default.createElement("li", { onClick: onClick, className: "border-bottom", style: {
            cursor: "pointer",
            display: "block",
            width: "100%",
            padding: "8px",
            backgroundColor: selected ? "#facc15" : "#f8f9fa",
        } }, matched && matched.length > 0 && (react_1.default.createElement("span", null, content === null || content === void 0 ? void 0 : content.split(new RegExp(`(${search})`, "gi")).map((part, index) => (react_1.default.createElement("span", { key: index },
        react_1.default.createElement("span", { style: {
                backgroundColor: matched.includes(part)
                    ? replaceValue
                        ? "#FFEFEB"
                        : "#ffff00"
                    : "transparent",
                textDecoration: matched.includes(part) && replaceValue
                    ? "line-through"
                    : "none",
            } }, part),
        matched.includes(part) && replaceValue && (react_1.default.createElement("span", { style: { backgroundColor: "#dafbe1" } }, replaceValue)))))))));
}
exports.default = FindResult;
